import { render, staticRenderFns } from "./ReportsStatistics.vue?vue&type=template&id=536aae35&"
import script from "./ReportsStatistics.vue?vue&type=script&lang=js&"
export * from "./ReportsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports